import React, { useContext, useState } from "react";
import Context from "../../../../Context";
import List from "../../../Misc/List";
import Filters from "../../../Misc/Filters";
import Sortings from "../../../Misc/Sortings";
import FieldsList from "../../../Misc/FieldsList";

function ApiLog() {
  const cx = useContext(Context);

  let search = [];
  let sort = [];

  let savedFields = localStorage.getItem("apiLogFields")
    ? JSON.parse(localStorage.getItem("apiLogFields"))
    : false;
  let fields = savedFields || ["id", "datetime", "username", "path", "json"];

  const [currentSearchJSON, changeCurrentSearch] = useState(
    JSON.stringify(search || [])
  );

  const [currentSortingsJSON, changeCurrentSortings] = useState(
    JSON.stringify(sort || [])
  );

  const [currentFieldsJSON, changeCurrentFields] = useState(
    JSON.stringify(fields || [])
  );

  const [showfilters, toggleFilters] = useState(false);

  function fieldsChange(fields) {
    localStorage.setItem("apiLogFields", JSON.stringify(fields));
    changeCurrentFields(JSON.stringify(fields));
  }

  function filtersChange(search) {
    changeCurrentSearch(JSON.stringify(search));
  }

  function sortingsChange(sortings) {
    changeCurrentSortings(JSON.stringify(sortings));
  }

  let flt = [
    {
      id: "datetime",
      title: cx.t("admin.apiLog.filter_datetime"),
      kind: "range",
      active: false,
      value: [],
    },
  ];

  let srt = [
    {
      id: "byCreatedASC",
      active: false,
      title: cx.t("admin.apiLog.sort_byCreatedASC"),
      value: ["datetime ASC"],
    },
    {
      id: "byCreatedDESC",
      active: false,
      title: cx.t("admin.apiLog.sort_byCreatedDESC"),
      value: ["datetime DESC"],
    },
  ];

  let flds = [
    "id",
    "datetime",
    "su",
    "session",
    "username",
    "path",
    "json",
    "nonce",
    "noncetime",
    "signature",
    "runtime",
    "eventid",
    "error",
  ];

  let filters = (
    <div
      className={`${
        showfilters ? "d-flex" : "d-none"
      }  align-items-center justify-content-end mt-0 py-5 px-7 mb-2 border-bottom w-100 shadow-sm`}
    >
      <Filters changeFn={filtersChange} filters={flt} />
    </div>
  );
  return (
    <>
      <div className="card card-custom gutter-b">
        <div className="card-header">
          <div className="card-title w-100 mr-0 d-flex align-items-center justify-content-between">
            <h3 className="card-label">{cx.t("admin.apiLog.title")}</h3>
            <div>
              <FieldsList
                changeFn={fieldsChange}
                fields={flds}
                activeFields={fields}
              />
              <button
                className="btn btn-light mr-2"
                onClick={() => toggleFilters(!showfilters)}
              >
                <i
                  className={`fa fa-filter p-0 ${
                    showfilters ? "text-primary" : "text-muted"
                  }`}
                ></i>
              </button>
              <Sortings changeFn={sortingsChange} sortings={srt} />
            </div>
          </div>
        </div>
        {filters}
        <div className="card-body">
          <List
            listKey="ApiLogList"
            search={currentSearchJSON}
            sort={currentSortingsJSON}
            fields={currentFieldsJSON}
            limit={10}
            keyField="id"
            path="/admin/api/log/list"
            table
          ></List>
        </div>
      </div>
    </>
  );
}

export default ApiLog;
